
<template>
<div class="mt-5 text-left">
    <b-form-group label-cols-lg="8" label-cols-sm="12" content-cols-lg="4" content-cols-sm="12" name="select-validation" :label="question.question" style="font-size: 1.2em">
      <b-form-radio-group required
      :id='category.category+question.name'
        v-model="selected"
        :options="options"
        :tag="category"
      >
      </b-form-radio-group>
    </b-form-group>
  </div>
  <!-- <div class="m-3 text-center">
    <b-form-group name="select-validation"  style="font-size: 1.2em">
      <label class="text-left col-8">{{question.question}}</label>
      <b-form-select class="col-2" required
        :id='category.category+question.name'
        v-model="selected"
        :options="options"
        :tag="category"
      ></b-form-select>
    </b-form-group>
  </div> -->
</template>

<script>
export default {
  props: ['question', 'category'],
  components: {},
  data() {
      return {
        selected: 3,
        options: [
          { value: 1, text: '1' },
          { value: 2, text: '2' },
          { value: 3, text: '3' },
          { value: 4, text: '4' },
          { value: 5, text: '5' }
        ]
      }
    },
  computed:{
  },
  mounted() {},
  methods: {
    // returnData(questionname, value, questiontag){
      
    //     this.$emit('newdata', {questionname, value, questiontag})
    // }
  },
  watch: {
    selected: function(){
      // console.log(this.selected)
      this.$emit('newdata', this.selected)
    }
  }
  }
</script>

<style scoped lang="scss">
// @import "./src/assets/scss/components/engagement/_EmployeeOverviewInDepth.scss";
</style>